(function ($) {
  DJ.addBehavior('Accordionjs', '.accordionjs', {
    attach: function (context, settings) {
      const accordionList = $(this);
      accordionList.accordionjs();
    },
    detach: function (context, settings) {}
  });
})(jQuery);
